import toast from "react-hot-toast";
import { Alert } from "@blueprintjs/core";

export const loadingToast = () => {
  toast.loading("Processing...");
};

export const getErrorMessage = (error, seen = new WeakSet()) => {
  if (typeof error === "string" || typeof error === "number") return String(error);
  if (error === null || error === undefined) return "";
  if (Array.isArray(error)) {
    return error.map((item) => getErrorMessage(item, seen)).filter(Boolean).join(", ");
  }
  if (typeof error === "object") {
    if (seen.has(error)) return "";
    seen.add(error);

    for (const key of ["detail", "message", "error", "errors"]) {
      const message = getErrorMessage(error[key], seen);
      if (message) return message;
    }
    for (const value of Object.values(error)) {
      const message = getErrorMessage(value, seen);
      if (message) return message;
    }
  }
  return "";
};

export const showErrorMsg = (error) => {
  const readableError = getErrorMessage(error);
  const errorLower = readableError.toLowerCase();
  const isSystemError = !!errorLower && (
    errorLower.includes("invalid input syntax") || 
    errorLower.includes("line ") || 
    errorLower.includes("psycopg2") || 
    errorLower.includes("reduce()") || 
    errorLower.includes("typeerror") || 
    errorLower.includes("valueerror")
  );
  const errorMsg =
    readableError.trim() !== "" && readableError !== "[object Object]" && !isSystemError
      ? readableError
      : "Sorry! Something went wrong, please try again.";
  toast(errorMsg, {
    icon: "❕",
    style: {
      borderRadius: "10px",
      background: "#E02401",
      color: "#fff",
    },
    duration: 5000,
  });
};

export const showSuccessMsg = (msg = "Request submitted successfully") => {
  toast(msg, {
    icon: "✅",
    style: {
      borderRadius: "10px",
      background: "#F2FFE9",
      color: "#000",
    },
  });
};

export const showRefundSubmitted = () => {
  toast("Refund Request Submitted", {
    icon: "✅",
    style: {
      borderRadius: "10px",
      background: "#F2FFE9",
      color: "#000",
    },
  });
};

export const showVoidSubmitted = () => {
  toast("Void Request Submitted", {
    icon: "✅",
    style: {
      borderRadius: "10px",
      background: "#F2FFE9",
      color: "#000",
    },
  });
};

export const showCaptureSubmitted = () => {
  toast("Capture Request Submitted", {
    icon: "✅",
    style: {
      borderRadius: "10px",
      background: "#F2FFE9",
      color: "#000",
    },
  });
};

export const showCancelSubmitted = () => {
  toast("Cancel Request Submitted", {
    icon: "✅",
    style: {
      borderRadius: "10px",
      background: "#F2FFE9",
      color: "#000",
    },
  });
};

export const showChargebackSubmitted = () => {
  toast("Chargeback Request Submitted", {
    icon: "✅",
    style: {
      borderRadius: "10px",
      background: "#F2FFE9",
      color: "#000",
    },
  });
};

export const showMismatchedSubmitted = () => {
  toast("Reconciled Successfully", {
    icon: "✅",
    style: {
      borderRadius: "10px",
      background: "#F2FFE9",
      color: "#000",
    },
  });
};

export const showApproved = () => {
  toast("Settlement Approved", {
    icon: "✅",
    style: {
      borderRadius: "10px",
      background: "#F2FFE9",
      color: "#000",
    },
  });
};

export const showRejected = () => {
  toast("Settlement Rejected", {
    icon: "✅",
    style: {
      borderRadius: "10px",
      background: "#F2FFE9",
      color: "#000",
    },
  });
};

export const showRequestSubmitted = () => {
  toast("Your request has been submitted", {
    icon: "✅",
    style: {
      borderRadius: "10px",
      background: "#F2FFE9",
      color: "#000",
    },
  });
};

let isToastAssigned = false;

export const showCustomToast = (onCloseCallback) => {
  if (isToastAssigned) return
  isToastAssigned = true;
  toast.custom(
    <Alert
      style={{ width: "auto" }}
      children={<p>Request access or contact <a href="mailto:support@oxygen7financial.com">support@oxygen7financial.com</a></p>}
      isOpen
      onClose={() => {
        if (onCloseCallback) {
          onCloseCallback();
        }
        toast.dismiss();
        isToastAssigned = false;
      }}
    />,
    {
      duration: Infinity
    }
  );
}

export const isShowAlertPermission = () => isToastAssigned

export const showConfirmDialog = (message) => {
  return new Promise((resolve) => {
    toast.custom(
      <div style={{
        background: '#fff',
        borderRadius: '10px',
        padding: '20px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        maxWidth: '400px',
        textAlign: 'center'
      }}>
        <p style={{ margin: '0 0 20px 0', color: '#000' }}>{message}</p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
          <button
            onClick={() => {
              toast.dismiss();
              resolve(true);
            }}
            style={{
              background: '#007bff',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              padding: '8px 16px',
              cursor: 'pointer'
            }}
          >
            Confirm
          </button>
          <button
            onClick={() => {
              toast.dismiss();
              resolve(false);
            }}
            style={{
              background: '#6c757d',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              padding: '8px 16px',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
        </div>
      </div>,
      {
        duration: Infinity,
        position: 'top-center'
      }
    );
  });
};
